import React from "react";

export const FARM_RAIN_HISTORY_HELP_TITLE = "Histórico de chuva e clima";

export function FarmRainHistoryHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Acompanhar a{" "}
        <strong>chuva registrada na fazenda</strong> e o{" "}
        <strong>clima da sede</strong> (temperatura, vento e umidade) ao longo
        do tempo.
      </p>

      <p>
        <strong>Duas telas:</strong> no topo, o ícone de <strong>chuva</strong>{" "}
        abre o mapa e o histórico dos pluviômetros. O ícone de{" "}
        <strong>clima</strong> abre temperatura, umidade e vento da fazenda,
        com gráficos do dia ou da semana.
      </p>

      <p>
        <strong>Clima da fazenda:</strong> a plataforma grava sozinha a cada{" "}
        <strong>10 minutos</strong> no ponto de referência da propriedade, mesmo
        sem máquina no campo. Na aba Clima, use{" "}
        <strong>Definir ponto de referência</strong> para informar latitude e
        longitude ou clicar no mapa satélite. Esse registro alimenta o pop-up
        do rastreamento quando o trabalho acontece <strong>dentro da cerca</strong>.
        Fora da fazenda, o rastro usa o clima do app, com a hora da última
        atualização.
      </p>

      <p>
        <strong>Pluviômetros espalhados pela fazenda:</strong> você pode ter
        vários pontos de coleta (cantos, centro, sub-fazendas). Cada um fica
        vinculado à posição GPS cadastrada.
      </p>

      <p>
        <strong>Como alimentar os dados (app de campo):</strong> o colaborador
        informa a <strong>quantidade de chuva (mm)</strong> diretamente no app.
        Pela <strong>geolocalização do celular</strong>, a plataforma{" "}
        <strong>reconhece automaticamente</strong> qual pluviômetro está mais
        próximo — não é preciso selecionar o ponto manualmente.
      </p>

      <p>
        <strong>O que aparece aqui na plataforma web:</strong>
      </p>
      <ul>
        <li>leituras registradas por pluviômetro e por período;</li>
        <li>planilha com histórico diário de cada ponto;</li>
        <li>
          <strong>mapa de calor (heatmap)</strong> recortado em{" "}
          <strong>cada subfazenda</strong> desenhada no mapa da fazenda (não
          na fazenda gestora nem em cada talhão). Escolha a subfazenda na
          lista, clique no perímetro ou dê zoom nela — o nome e a{" "}
          <strong>média de mm</strong> passam a ser os daquela fazenda;
        </li>
        <li>
          <strong>gráfico do ano</strong> (12 meses) em cima do gráfico de
          dias. Clique no mês para abrir os dias daquele mês. Sem meses
          futuros. O período personalizado fica embaixo do mapa. Abra{" "}
          <strong>Planilha do mês</strong> para ver o histórico e, se quiser,
          imprimir ou exportar o PDF;
        </li>
      </ul>

      <p>
        <strong>Cadastro de pluviômetros:</strong> na plataforma, clique em{" "}
        <strong>Adicionar pluviômetro no mapa</strong> e depois no talhão. Também
        dá para criar o ponto no app de campo, pela posição GPS. Mantenha pelo
        menos <strong>100 m entre pontos</strong> (até <strong>60 m</strong> de
        tolerância).
      </p>

      <p>
        <strong>Lançamento manual na plataforma:</strong> se alguém anotar a
        chuva no papel, o gestor lança ou corrige os <strong>mm</strong> aqui
        (lápis do ponto ou célula da planilha). Também dá para{" "}
        <strong>excluir</strong> um pluviômetro e filtrar por{" "}
        <strong>hoje, semana, mês ou data personalizada</strong>.
      </p>

      <p>
        <strong>Zoom do mapa:</strong> a tela abre perto dos pluviômetros, não
        na escala do país. Ajuste posição e zoom e clique em{" "}
        <strong>Salvar tela</strong> — este navegador reabre do jeito que você
        deixou.
      </p>
    </>
  );
}
